"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartFilled = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function HeartFilled(_a) {
  var children = _a.children,
      _b = _a.fill,
      fill = _b === void 0 ? 'currentColor' : _b,
      props = tslib_1.__rest(_a, ["children", "fill"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: "20",
    height: "19",
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M20.0002 5.55371C20.0002 2.51614 17.5378 0.0537109 14.5002 0.0537109C12.7821 0.107247 11.1589 0.853949 10.0002 2.12371C8.84161 0.853949 7.21834 0.107247 5.50024 0.0537109C2.46268 0.0537109 0.000244141 2.51614 0.000244141 5.55371C0.000244141 9.47371 4.75024 13.8037 7.00024 16.0537L9.28024 18.3337C9.42076 18.4744 9.6114 18.5535 9.81024 18.5537H10.1902C10.3891 18.5535 10.5797 18.4744 10.7202 18.3337L13.0002 16.0537C15.2502 13.8037 20.0002 9.47371 20.0002 5.55371Z",
    fill: fill
  }));
}

exports.HeartFilled = HeartFilled;